export const APP_NAME = "Water Tracker";

export const API_PREFIX = "/api/v1";

export const DEFAULT_API_BASE_URL = "";

export const DEFAULT_LOCALE = "en";

export const SUPPORTED_LOCALES = ["en", "de"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];
